class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    this.colorType = this.dataset.typeColorMenu || null;
  }

  connectedCallback() {
    if (!this.header) return;
    this.updateHeaderBottomPosition();
    this.resizeObserver = new ResizeObserver(() => this.updateHeaderBottomPosition());
    this.resizeObserver.observe(this.header);
  }

  disconnectedCallback() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
  }

  updateHeaderBottomPosition() {
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.colorType) {
      const className = `header-wrapper--type-color-content__${this.colorType}`;

      if (this.mainDetailsToggle.open) {
        this.header.classList.add(className);
      } else {
        this.header.classList.remove(className);
      }
    }
  }

  close() {
    if (this.header && this.colorType) {
      this.header.classList.remove(`header-wrapper--type-color-content__${this.colorType}`);
    }
    super.close();
  }
}

customElements.define('header-menu', HeaderMenu);
